export default {
  generateAssetsUrl(url: string): URL {
    return new URL(url, process.env.VUE_APP_BASE_ASSETS_URL);
  },
  generateWidgetUrl(url: string): URL {
    return new URL(url, process.env.VUE_APP_WIDGET_BASE_URL);
  },
}
